import React from 'react';

function MediumUsageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11.0833C11.6897 11.0833 11.4828 10.9792 11.2759 10.7708L6.31034 5.77083C5.89655 5.35417 5.89655 4.72917 6.31034 4.3125C6.72414 3.89583 7.34483 3.89583 7.75862 4.3125L12 8.58333L16.2414 4.3125C16.6552 3.89583 17.2759 3.89583 17.6897 4.3125C18.1034 4.72917 18.1034 5.35417 17.6897 5.77083L12.7241 10.7708C12.5172 10.9792 12.3103 11.0833 12 11.0833ZM17.5862 18.6875C18 18.2708 18 17.6458 17.5862 17.2292L12.7241 12.3333C12.3103 11.9167 11.6897 11.9167 11.2759 12.3333L6.41379 17.2292C6 17.6458 6 18.2708 6.41379 18.6875C6.82759 19.1042 7.44828 19.1042 7.86207 18.6875L12 14.5208L16.1379 18.6875C16.3448 18.8958 16.6552 19 16.8621 19C17.069 19 17.3793 18.8958 17.5862 18.6875Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default MediumUsageIcon;
